module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_ships-e1530e376b19bb821711221ab1e0fc8b.svg";